import {Component} from 'react';
import h from 'react-hyperscript';
import './ShareLink.scss';
import Button from 'Components/Buttons/Buttons';
import Menu from '@material-ui/core/Menu';
import {SURVEY} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';

class ShareLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      buttonText: 'Copy link',
    };
  }

  handleClose() {
    this.setState({
      anchorEl: null,
    });
  }

  handleShareLinkClick(e) {
    this.setState({
      anchorEl: e.currentTarget,
    });
    pushGTMEvent(SURVEY.TAG, {
      event: SURVEY.EVENT,
      action: {survey_action: SURVEY.ACTION.SHARE},
    });
  }

  doCopy(e) {
    e.preventDefault();
    const copyText = document.querySelector('.share-link-cta__url');
    copyText.select();
    document.execCommand('copy');
    this.setState({
      buttonText: 'Copied to clipboard',
    });
  }

  render() {
    const message = this.props.message ? this.props.message : 'Share link';
    return (
      h('div', {
        key: 'share-link-cta-wrapper',
        className: 'share-link',
        id: `share-link--${this.props.slug}`,
      }, [
        h(Button, {
          type: 'inline',
          buttonClasses: this.props.buttonClasses,
          to: '#',
          onClick: (e) => {
            if (!this.props.disabled) this.handleShareLinkClick(e);
          },
        }, [
          h('span', {
            key: 'share-link-cta-link',
            className: 'material-icons padding-right--micro',
          }, 'link'),
          h('span', {
            key: 'share-link-cta-title',
          }, message),
        ]),

        h(Menu, {
          slug: this.props.slug,
          anchorEl: this.state.anchorEl,
          keepMounted: true,
          key: `sharelink__menu--${this.props.slug}-key`,
          id: `sharelink__menu--${this.props.slug}`,
          open: Boolean(this.state.anchorEl),
          className: 'share-link__menu',
          onClose: () => {
            this.handleClose();
          },
        }, [
          h('div', {
            className: 'flex flex--align-start share-link__menu',
          }, [
            h('span', {
              key: 'share-link-cta-link',
              className: 'material-icons padding-right--micro',
            }, 'link'),

            h('div', {
              key: 'share-link__content',
              className: 'share-link__content',
            }, [
              h('input', {
                key: 'share-link-cta__url',
                className: 'share-link-cta__url margin-bottom--micro footnote',
                value: this.props.shareUrl,
                readOnly: true,
                onClick: (e) => {
                  this.doCopy(e);
                },
              }),
              h(Button, {
                key: 'share-link-cta-menu-button',
                className: 'button--left button--no-padding margin-top--micro',
                type: 'flat',
                to: '#',
                onClick: (e) => {
                  this.doCopy(e);
                },
              }, this.state.buttonText),
            ]),
          ]),
        ]),
      ])
    );
  }
}

export default ShareLink;
